import cnh from '~/helpers/cnh';
import formStyles from '~/styles/form.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  width?: 'full' | 'small';
};

export default function FormGroup({
  children,
  className,
  width = 'full',
}: Props) {
  const widthClass = width === 'full' ? '' : formStyles.formGroupSmall;

  return (
    <div className={cnh(formStyles.formGroup, widthClass, className)}>
      {children}
    </div>
  );
}
